import { render, staticRenderFns } from "./PortfolioCard.vue?vue&type=template&id=ea9ece8e&scoped=true&"
import script from "./PortfolioCard.vue?vue&type=script&lang=js&"
export * from "./PortfolioCard.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCard.vue?vue&type=style&index=0&id=ea9ece8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9ece8e",
  null
  
)

export default component.exports